import {BlockToFrameTransformer, generateInputFrame} from "../../core/frames/transformer/block-to-frame.transformer";
import {getInputValue} from "../../core/frames/transformer/block-to-value.factories";
import * as _ from "lodash";
import {
    arduinoFrameByExplanation,
    arduinoFrameByVariable
} from "../../core/frames/transformer/frame-transformer.helpers";
import {findFieldValue} from "../../core/blockly/helpers/block-data.helpers";
import {Variable} from "../../core/frames/arduino.frames";
import {VariableTypes} from "../../core/blockly/dto/variable.type";

export const simpleLoop: BlockToFrameTransformer = (
    blocks,
    block,
    variables,
    timeline,
    previousState
) => {
    const times = Math.abs(
        getInputValue(blocks, block, variables, timeline, "TIMES", 1, previousState)
    );

    return _.range(1, times + 1).reduce((prev, next) => {
        const beforeState = _.isEmpty(prev) ? previousState : prev[prev.length - 1];

        const loopFrame = arduinoFrameByExplanation(
            block.id,
            block.blockName,
            timeline,
            `Running loop ${next} out of ${times} times.`,
            beforeState
        );

        return [
            ...prev,
            loopFrame,
            ...generateInputFrame(
                block,
                blocks,
                variables,
                timeline,
                "DO",
                1,
                loopFrame
            ),
        ];
    }, []);
};

export const forLoop: BlockToFrameTransformer = (
    blocks,
    block,
    variables,
    timeline,
    previousState
) => {
    const from = getInputValue(
        blocks,
        block,
        variables,
        timeline,
        "FROM",
        1,
        previousState
    );

    const to = getInputValue(
        blocks,
        block,
        variables,
        timeline,
        "TO",
        1,
        previousState
    );

    const by = Math.abs(+findFieldValue(block, "BY"));

    const multiplyBy = from > to ? -1 : 1;

    let prevState = previousState;
    return _.range(from, to + multiplyBy, by * multiplyBy)
        .map((i, counter, array) => {
            const variableData = variables.find(
                (v) => v.id === findFieldValue(block, "VAR")
            );

            const newVariable: Variable = {
                id: variableData.id,
                name: variableData.name,
                value: i,
                type: VariableTypes.NUMBER,
            };
            const loopFrame = arduinoFrameByVariable(
                block.id,
                block.blockName,
                timeline,
                newVariable,
                `Running loop ${counter + 1} out ${array.length} times; ${
                    newVariable.name
                } = ${i}`,
                prevState,
                false,
                false,
                0,
                1

            );
            const states = [
                loopFrame,
                ...generateInputFrame(
                    block,
                    blocks,
                    variables,
                    timeline,
                    "DO",
                    1,
                    loopFrame
                ),
            ];
            prevState = _.cloneDeep(states[states.length - 1]);

            return states;
        })
        .flat(2);
};
